import { SystemAlertResponse } from "@src/providers/alerts/types";
import { useQuery } from "@tanstack/react-query";

const SYSTEM_ALERT_URL = "https://static.intelligems.io/app-alerts/system.json";
const POLL_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

const isAlertActive = (data: SystemAlertResponse): boolean => {
  if (typeof data.expires_at === "string" && data.expires_at.trim()) {
    const expiresAt = new Date(data.expires_at).getTime();
    if (!isNaN(expiresAt)) {
      return Date.now() < expiresAt;
    }
  }
  return Boolean(data.enabled);
};

const fetchSystemAlert = async (): Promise<SystemAlertResponse | null> => {
  const response = await fetch(`${SYSTEM_ALERT_URL}?t=${Date.now()}`);
  if (!response.ok) {
    return null;
  }

  const data = (await response.json()) as SystemAlertResponse;
  return isAlertActive(data) ? data : null;
};

export const useSystemAlert = () => {
  const { data } = useQuery({
    queryKey: ["system-alert"],
    queryFn: fetchSystemAlert,
    refetchInterval: POLL_INTERVAL_MS,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    staleTime: Infinity,
  });

  return data ?? null;
};
